import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ScannerPage from "./pages/ScannerPage";
import PortfolioDesignerPage from "./pages/PortfolioDesignerPage";
import OptionsGeneratorPage from "./pages/OptionsGeneratorPage";
import MarketOverviewPage from "./pages/MarketOverviewPage";
import MarketIndicatorsPage from "./pages/MarketIndicatorsPage";
import PortfolioAnalyzerPage from "./pages/PortfolioAnalyzerPage";
import PaydayAnomalyPage from "./pages/PaydayAnomalyPage";
import MoneyFlowPage from "./pages/MoneyFlowPage";
import GlobalMarketsPage from "./pages/GlobalMarketsPage";
import TodaysNewsPage from "./pages/TodaysNewsPage";
import OverviewPage from "./pages/OverviewPage";
import TradingPatternsPage from "./pages/TradingPatternsPage";
import OptionsPage from "./pages/OptionsPage";
import OptionsScannerLogPage from "./pages/OptionsScannerLogPage";
import InstitutionalPage from "./pages/InstitutionalPage";
import ChartsAnalysisPage from "./pages/ChartsAnalysisPage";
import DarkPoolPage from "./pages/DarkPoolPage";
import FundamentalsPage from "./pages/FundamentalsPage";
import PricePredictionPage from "./pages/PricePredictionPage";
import ContrarianTradersPage from "./pages/ContrarianTradersPage";
import TreasuryPage from "./pages/TreasuryPage";
import ExchangeSectorPage from "./pages/ExchangeSectorPage";
import AlertsManagerPage from "./pages/AlertsManagerPage";
import PoliticalTradesPage from "./pages/PoliticalTradesPage";
import SearchAttentionPage from "./pages/SearchAttentionPage";
import DailyRebalancingPage from "./pages/DailyRebalancingPage";
import EarlyWarningsPage from "./pages/EarlyWarningsPage";
import SectorAnalysisPage from "./pages/SectorAnalysisPage";
import AllStocksPage from "./pages/AllStocksPage";
import AllETFsPage from "./pages/AllETFsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import Navbar from "./components/Navbar";
import ErrorBoundary from "./components/ErrorBoundary";
import ServerWarmup from "./components/ServerWarmup";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import { AdminAuthProvider } from "./context/AdminAuthContext";

function App() {
  return (
    <div className="App min-h-screen bg-slate-950">
      <ErrorBoundary>
        <BrowserRouter>
          <AdminAuthProvider>
            <Routes>
              {/* Admin (separate realm — gated) */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/users" element={<AdminProtectedRoute><AdminUsersPage /></AdminProtectedRoute>} />
              <Route path="/admin" element={<AdminProtectedRoute><AdminUsersPage /></AdminProtectedRoute>} />

              {/* Public app (no login required) */}
              <Route path="*" element={
                <ServerWarmup>
                  <Navbar />
                  <main>
                    <Routes>
                      <Route path="/" element={<MarketOverviewPage />} />
                      <Route path="/stock" element={<Dashboard />} />
                      <Route path="/overview" element={<OverviewPage />} />
                      <Route path="/trading-patterns" element={<TradingPatternsPage />} />
                      <Route path="/options" element={<OptionsPage />} />
                      <Route path="/institutional" element={<InstitutionalPage />} />
                      <Route path="/charts" element={<ChartsAnalysisPage />} />
                      <Route path="/dark-pool" element={<DarkPoolPage />} />
                      <Route path="/fundamentals" element={<FundamentalsPage />} />
                      <Route path="/price-prediction" element={<PricePredictionPage />} />
                      <Route path="/contrarian" element={<ContrarianTradersPage />} />
                      <Route path="/market" element={<MarketOverviewPage />} />
                      <Route path="/market-indicators" element={<MarketIndicatorsPage />} />
                      <Route path="/scanner" element={<ScannerPage />} />
                      <Route path="/portfolio" element={<PortfolioDesignerPage />} />
                      <Route path="/options-generator" element={<OptionsGeneratorPage />} />
                      <Route path="/options-scanner-log" element={<OptionsScannerLogPage />} />
                      <Route path="/portfolio-analyzer" element={<PortfolioAnalyzerPage />} />
                      <Route path="/payday-anomaly" element={<PaydayAnomalyPage />} />
                      <Route path="/money-flow" element={<MoneyFlowPage />} />
                      <Route path="/global-markets" element={<GlobalMarketsPage />} />
                      <Route path="/news" element={<TodaysNewsPage />} />
                      <Route path="/treasury" element={<TreasuryPage />} />
                      <Route path="/exchange-sectors" element={<ExchangeSectorPage />} />
                      <Route path="/alerts" element={<AlertsManagerPage />} />
                      <Route path="/political-trades" element={<PoliticalTradesPage />} />
                      <Route path="/search-attention" element={<SearchAttentionPage />} />
                      <Route path="/signals/search-attention" element={<SearchAttentionPage />} />
                      <Route path="/daily-rebalancing" element={<DailyRebalancingPage />} />
                      <Route path="/early-warnings" element={<EarlyWarningsPage />} />
                      <Route path="/sector-analysis" element={<SectorAnalysisPage />} />
                      <Route path="/all-stocks" element={<AllStocksPage />} />
                      <Route path="/all-etfs" element={<AllETFsPage />} />
                    </Routes>
                  </main>
                </ServerWarmup>
              } />
            </Routes>
          </AdminAuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
